module.exports = __webpack_public_path__ + "243a40c3315559627a06dd8cb1b29fec.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/roguecompany/vice.png
// module id = 441
// module chunks = 0